import React, { ChangeEvent, useState , useEffect } from 'react'

import Typography from '@mui/material/Typography'
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tab,
  TextField,
  tooltipClasses,
  Tooltip
} from '@mui/material'
import { styled } from "@mui/material/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { TabContext, TabList } from '@mui/lab'
import AutoCompleteMultiSelect from '../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx'
import TextAreaComponents from '../../components/TextAreaComponents/TextAreaComponents.tsx'
import galleryIcon from './../../../assets/icons/gallery.png'
import plusIcon from './../../../assets/icons/plus.png'
import './AddItem.css'
import { Delete } from '@mui/icons-material'
import CancelIcon from '@mui/icons-material/Cancel'
import StickyHeadTable from '../../components/SpecificationTable/Specification.tsx'
import Details from './../../product/components/Details.tsx'
import Story from './../../product/components/Story.tsx'
import Instructions from './../../product/components/Instructions.tsx'
import Cancel from './../../../assets/icons/close.png'
import DetailsTable from '../../components/SpecificationTable/DetailsTable.tsx'
import SectionTable from './SectionTable.tsx'
import ChickenIcon from './../../../assets/icons/turkey.png'
import ChickenLegIcon from './../../../assets/icons/chicken-leg.png'
import Burger1Icon from './../../../assets/icons/burger1.png'
import Burger2Icon from './../../../assets/icons/burger.png'
import FullPizzaIcon from './../../../assets/icons/pizza.png'
import pizzaIcon from './../../../assets/icons/pizza (1).png'
import { getMinimalContentHeight } from '@mui/x-data-grid/hooks/features/rows/gridRowsUtils.js'
import axios from 'axios'
import LoadingView from '../../components/LoadingView/LoadingView.js'
import { toast } from 'react-toastify'
import SweetAlertModal from '../../components/SweetAlertModal/SweetAlertModal.js'
import jwt_decode from "jwt-decode";



function KeywordDialog(props) {
  
  const apiAddress = process.env.REACT_APP_SECRET;
  const Restauranttoken = JSON.parse(localStorage.getItem('restaurant'));
  const ParentRestauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));

 

  const [loadingModal, SetloadingModal] = React.useState(false);
  const [openConfirmaitonModal, setopenConfirmaitonModal]=useState(false)

  const closeLoadingModal = () => {
    SetloadingModal(false);
  }

 
  const [keyword, setKeyword] = useState(props.editKeywordData?props.editKeywordData.name:null)
  
 

  const handleKeyword = (event) => {
    setKeyword(event.target.value)
  }
console.log(keyword)
  const onClickSave = () => {
    SetloadingModal(true)
    setopenConfirmaitonModal(false)
    var valid=true
    if(!!keyword==false){
      valid=false
      SetloadingModal(false)
      toast.error("Keyword name is missing", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
    }

    let KeywordRestaurantMapperList = [];
    if(restaurantAdded.length>0){
      restaurantAdded.map((dt, i) => {
        KeywordRestaurantMapperList.push(dt.id);
        });
    }
   var obj={
    id: "string",
    keywordName: keyword,
    restaurantId: Restauranttoken.id,
    isActive: true,
    creatorId: "string",
    creationDate: "2023-08-21T06:38:08.240Z",
    modifierId: "string",
    modificationDate: "2023-08-21T06:38:08.240Z",
    restaurantIds : KeywordRestaurantMapperList
  }
  var  url = apiAddress + "/api/Keyword"
  if(valid){
    axios
    .post(url, obj)
    .then((response) => {
      SetloadingModal(false)
      toast.success("successfully submitted", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
      console.log(response.data);
      setKeyword(null)
      // props.reloadKeyword()
      props.onHandleKeywordDialog(false)
      
    });
  }
  
  
  }
 
const onClickUpdate=()=>{

  var valid=true
if(!!keyword==false)
{
  valid=false
  toast.error("Keyword name is missing", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
});
}
  var obj={
    id: props.editKeywordData.id,
    keywordName: keyword,
    restaurantId: Restauranttoken.id,
    isActive: true,
    creatorId: "string",
    creationDate: "2023-08-21T06:38:08.240Z",
    modifierId: "string",
    modificationDate: "2023-08-21T06:38:08.240Z"
  }
console.log(obj)
  var  url = apiAddress + "/api/Keyword"

  if(valid){
    axios
    .put(url, obj)
    .then((response) => {
      
      toast.success("successfully submitted", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
    // props.reloadKeyword()
    props.onHandleKeywordDialog(false)
    });
  }
 
}
  const handleClose = () => {
    props.onHandleKeywordDialog(false)
  }

  const [restaurantDatas, setRestaurantDatas] = React.useState([]);
  const [restaurantAdded, setRestaurantAdded] = useState([]);
  const restaurantAddedvalue = (newValue) => {
    setRestaurantAdded(newValue);
  }
  const [RestaurantErr, setRestaurantErr] = useState(false);

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 320,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }));

  useEffect(() => {
    loadRestaurantName()
  }, []);

  const token = localStorage.getItem("gotasteadmintoken");

  const [userId, setUserId] = useState();
  const loadRestaurantName = () => {
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) {}
    }
    console.log(decodedData.UserId);
    if (decodedData.UserId) {
      axios
        // .get(apiAddress + "/api/RestaurantUserMapper/getbyuserid/" + decodedData.UserId)
        .get(
          apiAddress +
            `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${ParentRestauranttoken.id}`
        )
        .then((response) => {
          var list = [];
          response.data.map((dt, i) => {
            var obj = {
              id: dt.restaurantId,
              title: dt.restaurantName,
            };
            list.push(obj);
          });
          console.log(list);
          setRestaurantDatas(list);
        });
    }
  };
  return (
    <div>
      <React.Fragment>
        <Dialog
         fullWidth={true}
          maxWidth='md'
          open={props.open}
          onClose={handleClose}
        >
           <SweetAlertModal headerText={"Are you sure?"} bodyText={"You want to save this?"} open={openConfirmaitonModal} onyes={onClickSave} close={() => { setopenConfirmaitonModal(false) }} />
          <LoadingView open={loadingModal} close={closeLoadingModal} />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>Add Keyword</DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={handleClose}>
                  <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
            <div>
            <Grid container sx={{ padding: "0.5rem" }}>
            <Grid item xs={2}>
              <div
                className="d-flex"
                style={{ paddingTop: "1rem", gap: "10px" }}
              >
                <Typography>Who can edit</Typography>
                <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography color="inherit">
                          Selected restaurants will be able to manage this Kayword.
                        </Typography>
                      </React.Fragment>
                    }
                  >
                    <InfoOutlinedIcon style={{ color: "#371B17" }} />
                  </HtmlTooltip>
              </div>
            </Grid>
            <Grid item xs={9}>
              {/* {EditRestaurant.length > 0 && restaurantDatas.length > 0 ? ( */}
              <AutoCompleteMultiSelect
                id={2}
                placeholder={"Restaurant"}
                datas={restaurantDatas}
                value={restaurantAddedvalue}
                val={restaurantAdded}
              />

              {/* ) : <img src={preloader} alt='preloader' style={{ width: '2rem' }} />
              } */}
              {RestaurantErr && (
                <span style={{ color: "red" }}>
                  This field is required
                </span>
              )}
            </Grid>
          </Grid>
              <Grid container sx={{ padding: '0.5rem' }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: '2rem' }}>
                    Keyword
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  
                  <TextField
                    label="Name"
                    value={keyword}
                    onChange={handleKeyword}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ sx: { color: '#371B17' } }}
                    defaultValue={props.editKeywordData?props.editKeywordData.name:''}
                  />
                </Grid>
              </Grid>
              

              <Grid container sx={{ padding: '0.5rem' }}>
                <Grid item xs={8}></Grid>

                <Grid item xs={4}>
                  {props.editKeywordData?(
                  <Button className="AddItemButtons" onClick={onClickUpdate}>
                    Update
                  </Button>
                  ):(
                    <Button className="AddItemButtons" onClick={() => { setopenConfirmaitonModal(true) }}>
                    Save
                  </Button>
                  )
                  }
                </Grid>
              </Grid>

              
            </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    </div>
  )
}

export default KeywordDialog
